/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum hazmat_override_source {
  CARRIER = 'carrier',
  STAFF = 'staff',
  SYSTEM = 'system',
}
